import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '../i18n';
import Home from '../pages/home';
import Preloader from './preloader';

const Routing = () => {
  const [done, setDone] = useState(false);

  return (
    <BrowserRouter>
      {!done && <Preloader onComplete={() => setDone(true)} />}
      <Routes>
        <Route path='/' element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
